/* Imports */
import { API_HELPER } from "@/helpers/api.js";

/* Exports */
// API services that can be invoked on the modules
export const PAGES_SERVICE = {postPage, getPages, putPage, deletePageById, getPageBySlug};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Pages";

/* Services */
//Service to create pages
function postPage(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'POST',
        headers: { "Content-Type":"application/json" },
        body: JSON.stringify(input)
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to get paginated pages
function getPages(queryParams)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'GET'
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}


//Service to update pages
function putPage(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'PUT',
        headers: { "Content-Type":"application/json" },
        body: JSON.stringify(input)
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to remove pages
function deletePageById(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id]);

    const requestOptions = {
        method: 'DELETE'
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to get pages by slug
function getPageBySlug(slug)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, slug]);

    const requestOptions = {
        method: 'GET'
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

